export default __webpack_public_path__ + "static/media/greeni-1.96b50f3e.jpg";